import { TrackingCustomEvents } from '@/constants/constants';
import { trackCustomEvent } from '@/lib/appInsights';
import { useUser } from '@/state/UserContext';
import { useIsAuthenticated } from '@azure/msal-react';

interface ListenButtonProps {
  to: string;
  variant: 'spotify' | 'youtube';
}

function ListenButton({ variant, to }: ListenButtonProps) {
  const { email, userId } = useUser();
  const isAuthenticated = useIsAuthenticated();

  function handleClick() {
    window.open(to, '_blank');

    const trackingEvent =
      variant === 'spotify'
        ? TrackingCustomEvents.click.podcast.listenOnSpotify
        : TrackingCustomEvents.click.podcast.listenOnYoutube;

    trackCustomEvent(trackingEvent, {
      user_auth_status: isAuthenticated ? 'logged_in' : 'anonymous',
      user_email: email ?? 'anonymous',
      user_id: userId ?? 'anonymous',
    });
  }

  return (
    <button
      onClick={handleClick}
      className='gradient-border rounded-md flex gap-3 items-center w-[max-content] p-3 px-4 hover:opacity-70 transition-all'
    >
      {variant === 'spotify' ? (
        <img src='/social-logos/spotify-logo.png' alt='Spotify Logo' width={28} height={28} />
      ) : (
        <img src='/social-logos/youtube-logo.png' alt='YouTube Logo' width={34} height={24} />
      )}
      <span className='mt-[1px] font-semibold gradient-text uppercase text-[1.125rem]'>
        Listen on {variant === 'spotify' ? 'Spotify' : 'YouTube'}
      </span>
    </button>
  );
}

export default ListenButton;
